import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const fetchProperties = (params = {}) =>
  api.get("/properties", { params }).then((r) => r.data);

export const fetchFeaturedProperties = (limit = 3) =>
  api.get("/properties/collection/featured", { params: { limit } }).then((r) => r.data);

export const fetchProperty = (reference) =>
  api.get(`/properties/${encodeURIComponent(reference)}`).then((r) => r.data);

export const postContact = (data) => api.post("/contact", data).then((r) => r.data);

export const postViewing = (data) =>
  api.post("/viewing-experience", data).then((r) => r.data);

export const chatWithMia = (session_id, message, language = "nl") =>
  api
    .post("/chat/mia", { session_id, message, language })
    .then((r) => r.data);

export const fetchBlogList = () => api.get("/blog").then((r) => r.data);
export const fetchBlogPost = (slug) =>
  api.get(`/blog/${slug}`).then((r) => r.data);
